const industryCategoryArr = [
  {
      "序号": "一",
      "行业编码": "A",
      "类别名称": "农、林、牧、渔业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "A01",
      "类别名称": "农业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "A011",
      "类别名称": "谷物种植",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "A012",
      "类别名称": "豆类、油料和薯类种植",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "A013",
      "类别名称": "棉、麻、糖、烟草种植",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "A014",
      "类别名称": "蔬菜、食用菌及园艺作物种植",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "A015",
      "类别名称": "水果种植",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "A016",
      "类别名称": "坚果、含油果、香料和饮料作物种植",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "A017",
      "类别名称": "中药材种植",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 8,
      "行业编码": "A018",
      "类别名称": "草种植及割草",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 9,
      "行业编码": "A019",
      "类别名称": "其他农业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "A02",
      "类别名称": "林业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "A021",
      "类别名称": "林木育种和育苗",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "A022",
      "类别名称": "造林和更新",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "A023",
      "类别名称": "森林经营、管护和改培",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "A024",
      "类别名称": "木材和竹材采运",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "A025",
      "类别名称": "林产品采集",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（三）",
      "行业编码": "A03",
      "类别名称": "畜牧业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "A031",
      "类别名称": "牲畜饲养",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1.1,
      "行业编码": "—",
      "类别名称": "牲畜饲养（牛、羊）",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 1.2,
      "行业编码": "—",
      "类别名称": "牲畜饲养（其他）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "A032",
      "类别名称": "家禽饲养",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "A033",
      "类别名称": "狩猎和捕捉动物",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "A039",
      "类别名称": "其他畜牧业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（四）",
      "行业编码": "A04",
      "类别名称": "渔业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "A041",
      "类别名称": "水产养殖",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "A042",
      "类别名称": "水产捕捞",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（五）",
      "行业编码": "A05",
      "类别名称": "农、林、牧、渔专业及辅助性活动",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "A051",
      "类别名称": "农业专业及辅助性活动",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "A052",
      "类别名称": "林业专业及辅助性活动",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "A053",
      "类别名称": "畜牧专业及辅助性活动",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 3.1,
      "行业编码": "—",
      "类别名称": "畜牧专业及辅助性活动（牛、羊）",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3.2,
      "行业编码": "—",
      "类别名称": "畜牧专业及辅助性活动（其他）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "A054",
      "类别名称": "渔业专业及辅助性活动",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "二",
      "行业编码": "B",
      "类别名称": "采矿业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "B06",
      "类别名称": "煤炭开采和洗选业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "B061",
      "类别名称": "烟煤和无烟煤开采洗选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "B062",
      "类别名称": "褐煤开采洗选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "B069",
      "类别名称": "其他煤炭采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二）",
      "行业编码": "B07",
      "类别名称": "石油和天然气开采业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "B071",
      "类别名称": "石油开采",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "B072",
      "类别名称": "天然气开采",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 2.1,
      "行业编码": "—",
      "类别名称": "含硫天然气开采",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2.2,
      "行业编码": "—",
      "类别名称": "其他天然气开采",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（三）",
      "行业编码": "B08",
      "类别名称": "黑色金属矿采选业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "B081",
      "类别名称": "铁矿采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "B082",
      "类别名称": "锰矿、铬矿采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "B089",
      "类别名称": "其他黑色金属矿采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（四）",
      "行业编码": "B09",
      "类别名称": "有色金属矿采选业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "B091",
      "类别名称": "常用有色金属矿采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "B092",
      "类别名称": "贵金属矿采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "B093",
      "类别名称": "稀有稀土金属矿采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（五）",
      "行业编码": "B10",
      "类别名称": "非金属矿采选业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "B101",
      "类别名称": "土砂石开采",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "B102",
      "类别名称": "化学矿开采",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "B103",
      "类别名称": "采盐",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "B109",
      "类别名称": "石棉、石英砂及其他非金属矿采选",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（六）",
      "行业编码": "B11",
      "类别名称": "开采专业及辅助性活动",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "B111",
      "类别名称": "煤炭开采和洗选专业及辅助性活动",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "B112",
      "类别名称": "石油和天然气开采专业及辅助性活动",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "B119",
      "类别名称": "其他开采专业及辅助性活动",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（七）",
      "行业编码": "B12",
      "类别名称": "其他采矿业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "B120",
      "类别名称": "其他采矿业",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "三",
      "行业编码": "C",
      "类别名称": "制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "C13",
      "类别名称": "农副食品加工业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C131",
      "类别名称": "谷物磨制",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C132",
      "类别名称": "饲料加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C133",
      "类别名称": "植物油加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "C134",
      "类别名称": "制糖业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C135",
      "类别名称": "屠宰及肉类加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "C136",
      "类别名称": "水产品加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "C137",
      "类别名称": "蔬菜、菌类、水果和坚果加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 8,
      "行业编码": "C139",
      "类别名称": "其他农副食品加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "C14",
      "类别名称": "食品制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C141",
      "类别名称": "焙烤食品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C142",
      "类别名称": "糖果、巧克力及蜜饯制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C143",
      "类别名称": "方便食品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "C144",
      "类别名称": "乳制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C145",
      "类别名称": "罐头食品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "C146",
      "类别名称": "调味品、发酵制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "C149",
      "类别名称": "其他食品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（三）",
      "行业编码": "C15",
      "类别名称": "酒、饮料和精制茶制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C151",
      "类别名称": "酒的制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C152",
      "类别名称": "饮料制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C153",
      "类别名称": "精制茶加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（四）",
      "行业编码": "C16",
      "类别名称": "烟草制品业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C161",
      "类别名称": "烟叶复烤",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C162",
      "类别名称": "卷烟制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C169",
      "类别名称": "其他烟草制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（五）",
      "行业编码": "C17",
      "类别名称": "纺织业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C171",
      "类别名称": "棉纺织及印染精加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C172",
      "类别名称": "毛纺织及染整精加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C173",
      "类别名称": "麻纺织及染整精加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C174",
      "类别名称": "丝绢纺织及印染精加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C175",
      "类别名称": "化纤织造及印染精加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C176",
      "类别名称": "针织或钩针编织物及其制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "C177",
      "类别名称": "家用纺织制成品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 8,
      "行业编码": "C178",
      "类别名称": "产业用纺织制成品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（六）",
      "行业编码": "C18",
      "类别名称": "纺织服装、服饰业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C181",
      "类别名称": "机织服装制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C182",
      "类别名称": "针织或钩针编织服装制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C183",
      "类别名称": "服饰制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（七）",
      "行业编码": "C19",
      "类别名称": "皮革、毛皮、羽毛及其制品和制鞋业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C191",
      "类别名称": "皮革鞣制加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C192",
      "类别名称": "皮革制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C193",
      "类别名称": "毛皮鞣制及制品加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C194",
      "类别名称": "羽毛(绒)加工及制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C195",
      "类别名称": "制鞋业*",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（八）",
      "行业编码": "C20",
      "类别名称": "木材加工和木、竹、藤、棕、草制品业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C201",
      "类别名称": "木材加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C202",
      "类别名称": "人造板制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C203",
      "类别名称": "木质制品制造*",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C204",
      "类别名称": "竹、藤、棕、草等制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（九）",
      "行业编码": "C21",
      "类别名称": "家具制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C211",
      "类别名称": "木质家具制造*",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C212",
      "类别名称": "竹、藤家具制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C213",
      "类别名称": "金属家具制造*",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C214",
      "类别名称": "塑料家具制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C219",
      "类别名称": "其他家具制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（十）",
      "行业编码": "C22",
      "类别名称": "造纸和纸制品业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C221",
      "类别名称": "纸浆制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C222",
      "类别名称": "造纸",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C223",
      "类别名称": "纸制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（十一）",
      "行业编码": "C23",
      "类别名称": "印刷和记录媒介复制业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C231",
      "类别名称": "印刷*",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C232",
      "类别名称": "装订及印刷相关服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（十二）",
      "行业编码": "C24",
      "类别名称": "文教、工美、体育和娱乐用品制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C241",
      "类别名称": "文教办公用品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C242",
      "类别名称": "乐器制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C243",
      "类别名称": "工艺美术及礼仪用品制造",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 3.1,
      "行业编码": "—",
      "类别名称": "工艺美术及礼仪用品制造（雕塑、金属漆器、珠宝）",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3.2,
      "行业编码": "—",
      "类别名称": "工艺美术及礼仪用品制造（其他）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "C244",
      "类别名称": "体育用品制造",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 4.1,
      "行业编码": "—",
      "类别名称": "体育用品制造（高尔夫球制品）",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4.2,
      "行业编码": "—",
      "类别名称": "体育用品制造（其他）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C245",
      "类别名称": "玩具制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "C246",
      "类别名称": "游艺器材及娱乐用品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（十三）",
      "行业编码": "C25",
      "类别名称": "石油、煤炭及其他燃料加工业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C251",
      "类别名称": "精炼石油产品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C252",
      "类别名称": "煤炭加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C253",
      "类别名称": "核燃料加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C254",
      "类别名称": "生物质燃料加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（十四）",
      "行业编码": "C26",
      "类别名称": "化学原料和化学制品制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C261",
      "类别名称": "基础化学原料制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C262",
      "类别名称": "肥料制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C263",
      "类别名称": "农药制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C264",
      "类别名称": "涂料、油墨、颜料及类似产品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C265",
      "类别名称": "合成材料制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C266",
      "类别名称": "专用化学产品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "C267",
      "类别名称": "炸药、火工及焰火产品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "C268",
      "类别名称": "日用化学产品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（十五）",
      "行业编码": "C27",
      "类别名称": "医药制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C271",
      "类别名称": "化学药品原料药制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C272",
      "类别名称": "化学药品制剂制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C273",
      "类别名称": "中药饮片加工",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "C274",
      "类别名称": "中成药生产",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C275",
      "类别名称": "兽用药品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "C276",
      "类别名称": "生物药品制品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "C277",
      "类别名称": "卫生材料及医药用品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 8,
      "行业编码": "C278",
      "类别名称": "药用辅料及包装材料制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（十六）",
      "行业编码": "C28",
      "类别名称": "化学纤维制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C281",
      "类别名称": "纤维素纤维原料及纤维制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C282",
      "类别名称": "合成纤维制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C283",
      "类别名称": "生物基材料制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（十七）",
      "行业编码": "C29",
      "类别名称": "橡胶和塑料制品业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C291",
      "类别名称": "橡胶制品业",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C292",
      "类别名称": "塑料制品业",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（十八）",
      "行业编码": "C30",
      "类别名称": "非金属矿物制品业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C301",
      "类别名称": "水泥、石灰和石膏制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C302",
      "类别名称": "石膏、水泥制品及类似制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C303",
      "类别名称": "砖瓦、石材等建筑材料制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C304",
      "类别名称": "玻璃制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C305",
      "类别名称": "玻璃制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C306",
      "类别名称": "玻璃纤维和玻璃纤维增强塑料制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "C307",
      "类别名称": "陶瓷制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "C308",
      "类别名称": "耐火材料制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 9,
      "行业编码": "C309",
      "类别名称": "石墨及其他非金属矿物制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（十九）",
      "行业编码": "C31",
      "类别名称": "黑色金属冶炼和压延加工业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C311",
      "类别名称": "炼铁",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C312",
      "类别名称": "炼钢",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C313",
      "类别名称": "钢压延加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C314",
      "类别名称": "铁合金冶炼",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二十）",
      "行业编码": "C32",
      "类别名称": "有色金属冶炼和压延加工业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C321",
      "类别名称": "常用有色金属冶炼",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C322",
      "类别名称": "贵金属冶炼",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C323",
      "类别名称": "稀有稀土金属冶炼",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C324",
      "类别名称": "有色金属合金制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C325",
      "类别名称": "有色金属压延加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二十一）",
      "行业编码": "C33",
      "类别名称": "金属制品业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C331",
      "类别名称": "结构性金属制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C332",
      "类别名称": "金属工具制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C333",
      "类别名称": "集装箱及金属包装容器制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C334",
      "类别名称": "金属丝绳及其制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C335",
      "类别名称": "建筑、安全用金属制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C336",
      "类别名称": "金属表面处理及热处理加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "C337",
      "类别名称": "搪瓷制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "C338",
      "类别名称": "金属制日用品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 9,
      "行业编码": "C339",
      "类别名称": "铸造及其他金属制品制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二十二）",
      "行业编码": "C34",
      "类别名称": "通用设备制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C341",
      "类别名称": "锅炉及原动设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C342",
      "类别名称": "金属加工机械制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C343",
      "类别名称": "物料搬运设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C344",
      "类别名称": "泵、阀门、压缩机及类似机械制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C345",
      "类别名称": "轴承、齿轮和传动部件制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C346",
      "类别名称": "烘炉、风机、包装等设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "C347",
      "类别名称": "文化、办公用机械制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "C348",
      "类别名称": "通用零部件制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 9,
      "行业编码": "C349",
      "类别名称": "其他通用设备制造业",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二十三）",
      "行业编码": "C35",
      "类别名称": "专用设备制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C351",
      "类别名称": "采矿、冶金、建筑专用设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C352",
      "类别名称": "化工、木材、非金属加工专用设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C353",
      "类别名称": "食品、饮料、烟草及饲料生产专用设备制造",
      "严重": " √",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C354",
      "类别名称": "印刷、制药、日化及日用品生产专用设备制造",
      "严重": " √",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C355",
      "类别名称": "纺织、服装和皮革加工专用设备制造",
      "严重": "√",
      "一般": " "
  },
  {
      "序号": 6,
      "行业编码": "C356",
      "类别名称": "电子和电工机械专用设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "C357",
      "类别名称": "农、林、牧、渔专用机械制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "C358",
      "类别名称": "医疗仪器设备及器械制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 9,
      "行业编码": "C359",
      "类别名称": "环保、邮政、社会公共服务及其他专用设备制造",
      "严重": " √",
      "一般": ""
  },
  {
      "序号": "（二十四）",
      "行业编码": "C36",
      "类别名称": "汽车制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C361",
      "类别名称": "汽车整车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C362",
      "类别名称": "汽车用发动机制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C363",
      "类别名称": "改装汽车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C364",
      "类别名称": "低速汽车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C365",
      "类别名称": "电车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C366",
      "类别名称": "汽车车身、挂车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "C367",
      "类别名称": "汽车零部件及配件制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二十五）",
      "行业编码": "C37",
      "类别名称": "铁路、船舶、航空航天和其他运输设制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C371",
      "类别名称": "铁路运输设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C372",
      "类别名称": "城市轨道交通设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C373",
      "类别名称": "船舶及相关装置制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C374",
      "类别名称": "航空、航天器及设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C375",
      "类别名称": "摩托车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C376",
      "类别名称": "自行车和残疾人座车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "C377",
      "类别名称": "助动车制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "C378",
      "类别名称": "非公路休闲车及零配件制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 9,
      "行业编码": "C379",
      "类别名称": "潜水救捞及其他未列明运输设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二十六）",
      "行业编码": "C38",
      "类别名称": "电气机械和器材制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C381",
      "类别名称": "电机制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C382",
      "类别名称": "输配电及控制设备制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C383",
      "类别名称": "电线、电缆、光缆及电工器材制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "C384",
      "类别名称": "电池制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C385",
      "类别名称": "家用电力器具制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "C386",
      "类别名称": "非电力家用器具制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "C387",
      "类别名称": "照明器具制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 8,
      "行业编码": "C389",
      "类别名称": "其他电气机械及器材制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二十七）",
      "行业编码": "C39",
      "类别名称": "计算机、通信和其他电子设备制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C391",
      "类别名称": "计算机制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C392",
      "类别名称": "通信设备制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C393",
      "类别名称": "广播电视设备制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "C394",
      "类别名称": "雷达及配套设备制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C395",
      "类别名称": "非专业视听设备制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "C396",
      "类别名称": "智能消费设备制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "C397",
      "类别名称": "电子器件制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "C398",
      "类别名称": "电子元件及电子专用材料制造",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 9,
      "行业编码": "C399",
      "类别名称": "其他电子设备制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二十八）",
      "行业编码": "C40",
      "类别名称": "仪器仪表制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C401",
      "类别名称": "通用仪器仪表制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C402",
      "类别名称": "专用仪器仪表制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C403",
      "类别名称": "钟表与计时仪器制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "C404",
      "类别名称": "光学仪器制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "C405",
      "类别名称": "衡器制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "C409",
      "类别名称": "其他仪器仪表制造业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二十九）",
      "行业编码": "C41",
      "类别名称": "其他制造业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C411",
      "类别名称": "日用杂品制造",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C412",
      "类别名称": "核辐射加工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "C419",
      "类别名称": "其他未列明制造业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（三十）",
      "行业编码": "C42",
      "类别名称": "废弃资源综合利用业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C421",
      "类别名称": "金属废料和碎屑加工处理",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "C422",
      "类别名称": "非金属废料和碎屑加工处理",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（三十一）",
      "行业编码": "C43",
      "类别名称": "金属制品、机械和设备修理业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "C431",
      "类别名称": "金属制品修理",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "C432",
      "类别名称": "通用设备修理",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "C433",
      "类别名称": "专用设备修理",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "C434",
      "类别名称": "铁路、船舶、航空航天等运输设备修理",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "C435",
      "类别名称": "电气设备修理",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "C436",
      "类别名称": "仪器仪表修理",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 7,
      "行业编码": "C439",
      "类别名称": "其他机械和设备修理业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "四",
      "行业编码": "D",
      "类别名称": "电力、热力、燃气及水生产和供应业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "D44",
      "类别名称": "电力、热力生产和供应业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "D441",
      "类别名称": "电力生产",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1.1,
      "行业编码": "—",
      "类别名称": "电力生产（火力生产、热电联产、核力发电、生物质能发电）",
      "严重": " √",
      "一般": ""
  },
  {
      "序号": 1.2,
      "行业编码": "—",
      "类别名称": "电力生产（其他）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "D442",
      "类别名称": "电力供应",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "D443",
      "类别名称": "热力生产和供应",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 3.1,
      "行业编码": "—",
      "类别名称": "热力生产和供应（燃煤、核能）",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3.2,
      "行业编码": "—",
      "类别名称": "热力生产和供应（其他）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "D45",
      "类别名称": "燃气生产和供应业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "D451",
      "类别名称": "燃气生产和供应业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1.1,
      "行业编码": "—",
      "类别名称": "燃气生产",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 1.2,
      "行业编码": "—",
      "类别名称": "燃气供应",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "D452",
      "类别名称": "生物质燃气生产和供应业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（三）",
      "行业编码": "D46",
      "类别名称": "水的生产和供应业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "D461",
      "类别名称": "自来水生产和供应",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "D462",
      "类别名称": "污水处理及其再生利用",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "D463",
      "类别名称": "海水淡化处理",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "D469",
      "类别名称": "其他水的处理、利用和分配",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "五",
      "行业编码": "E",
      "类别名称": "建筑业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "E47",
      "类别名称": "房屋建筑业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "E471",
      "类别名称": "住宅房屋建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "E472",
      "类别名称": "体育场馆建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "E479",
      "类别名称": "其他房屋建筑业",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（二）",
      "行业编码": "E48",
      "类别名称": "土木工程建筑业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "E481",
      "类别名称": "铁路、道路、隧道和桥梁工程建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "E482",
      "类别名称": "水利和水运工程建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "E483",
      "类别名称": "海洋工程建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "E484",
      "类别名称": "工矿工程建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 5,
      "行业编码": "E485",
      "类别名称": "架线和管道工程建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 6,
      "行业编码": "E486",
      "类别名称": "节能环保工程施工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 7,
      "行业编码": "E487",
      "类别名称": "电力工程施工",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 8,
      "行业编码": "E489",
      "类别名称": "其他土木工程建筑",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（三）",
      "行业编码": "E49",
      "类别名称": "建筑安装业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "E491",
      "类别名称": "电气安装",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "E492",
      "类别名称": "管道和设备安装",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "E499",
      "类别名称": "其他建筑安装业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（四）",
      "行业编码": "E50",
      "类别名称": "建筑装饰、装修和其他建筑业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "E501",
      "类别名称": "建筑装饰和装修业",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 2,
      "行业编码": "E502",
      "类别名称": "建筑物拆除和场地准备",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 3,
      "行业编码": "E503",
      "类别名称": "提供施工设备服务",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 4,
      "行业编码": "E509",
      "类别名称": "其他未列明建筑业",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "六",
      "行业编码": "F",
      "类别名称": "批发和零售业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "F51",
      "类别名称": "批发业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "F516",
      "类别名称": "矿产品、建材及化工产品批发",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "F52",
      "类别名称": "零售业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "F526",
      "类别名称": "汽车、摩托车、零配件和燃料及其他动力销售",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1.1,
      "行业编码": "F5265",
      "类别名称": "机动车燃油零售",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 1.2,
      "行业编码": "F5266",
      "类别名称": "机动车燃气零售",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "七",
      "行业编码": "G",
      "类别名称": "交通运输、仓储和邮政业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "G53",
      "类别名称": "铁路运输业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "G533",
      "类别名称": "铁路运输辅助活动",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "G54",
      "类别名称": "道路运输业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "G541",
      "类别名称": "城市公共交通运输（城市轨道交通）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "G544",
      "类别名称": "道路运输辅助活动",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（三）",
      "行业编码": "G55",
      "类别名称": "水上运输业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "G551",
      "类别名称": "水上旅客运输",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "G552",
      "类别名称": "水上货物运输",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "G553",
      "类别名称": "水上运输辅助活动",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（四）",
      "行业编码": "G56",
      "类别名称": "航空运输业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "G561",
      "类别名称": "航空客货运输",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "G562",
      "类别名称": "通用航空服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "G563",
      "类别名称": "航空运输辅助活动",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（五）",
      "行业编码": "G57",
      "类别名称": "管道运输业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "G571",
      "类别名称": "海底管道运输",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "G572",
      "类别名称": "陆地管道运输",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（六）",
      "行业编码": "G59",
      "类别名称": "装卸搬运和仓储业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "G591",
      "类别名称": "装卸搬运",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "G593",
      "类别名称": "低温仓储",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "G594",
      "类别名称": "危险品仓储",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "G595",
      "类别名称": "谷物、棉花等农产品仓储",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 5,
      "行业编码": "G596",
      "类别名称": "中药材仓储",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 6,
      "行业编码": "G599",
      "类别名称": "其他仓储业",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "八",
      "行业编码": "H",
      "类别名称": "住宿和餐饮业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "H62",
      "类别名称": "餐饮业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "H621",
      "类别名称": "正餐服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "H622",
      "类别名称": "快餐服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "九",
      "行业编码": "M",
      "类别名称": "科学研究和技术服务业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "M73",
      "类别名称": "研究和试验发展",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "M731",
      "类别名称": "自然科学研究和试验发展",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "M732",
      "类别名称": "工程和技术研究和试验发展",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 3,
      "行业编码": "M733",
      "类别名称": "农业科学和试验发展",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 4,
      "行业编码": "M734",
      "类别名称": "医学研究和试验发展",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "M74",
      "类别名称": "专业技术服务业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "M746",
      "类别名称": "环境与生态监测检测服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "十",
      "行业编码": "N",
      "类别名称": "水利、环境和公共设施管理业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "N77",
      "类别名称": "生态保护和环境治理业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "N772",
      "类别名称": "环境治理业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1.1,
      "行业编码": "—",
      "类别名称": "环境治理业（危险废物治理、放射性废物治理）",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": 1.2,
      "行业编码": "—",
      "类别名称": "环境治理业（其他）",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "N78",
      "类别名称": "公共设施管理业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "N782",
      "类别名称": "环境卫生管理",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "十一",
      "行业编码": "O",
      "类别名称": "居民服务、修理和其他服务业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "O80",
      "类别名称": "居民服务业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "O803",
      "类别名称": "洗染服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": 2,
      "行业编码": "O808",
      "类别名称": "殡葬服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "（二）",
      "行业编码": "O81",
      "类别名称": "机动车、电子产品和日用产品修理业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "O811",
      "类别名称": "汽车、摩托车修理与维护*",
      "严重": "√",
      "一般": ""
  },
  {
      "序号": "（三）",
      "行业编码": "O82",
      "类别名称": "其他服务业",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "O822",
      "类别名称": "宠物服务",
      "严重": "",
      "一般": "√"
  },
  {
      "序号": "十二",
      "行业编码": "Q",
      "类别名称": "卫生和社会工作",
      "严重": "",
      "一般": ""
  },
  {
      "序号": "（一）",
      "行业编码": "Q84",
      "类别名称": "卫生",
      "严重": "",
      "一般": ""
  },
  {
      "序号": 1,
      "行业编码": "Q841",
      "类别名称": "医院",
      "严重": "",
      "一般": "√"
  }
]

const industryCategoryObj = { 
  A: 1,   
  A01: 1, 
  A011: 1,
  A012: 1,
  A013: 1,
  A014: 1,
  A015: 1,
  A016: 1,
  A017: 1,
  A018: 1,
  A019: 1,
  A02: 1, 
  A021: 1,
  A022: 1,
  A023: 1,
  A024: 1,
  A025: 1,
  A03: 1,
  A031: 1,
  A032: 1,
  A033: 1,
  A039: 1,
  A04: 1,
  A041: 1,
  A042: 1,
  A05: 1,
  A051: 1,
  A052: 1,
  A053: 1,
  A054: 1,
  B: 1,
  B06: 1,
  B061: 0,
  B062: 0,
  B069: 0,
  B07: 1,
  B071: 0,
  B072: 1,
  B08: 1,
  B081: 0,
  B082: 0,
  B089: 0,
  B09: 1,
  B091: 0,
  B092: 0,
  B093: 0,
  B10: 1,
  B101: 0,
  B102: 0,
  B103: 1,
  B109: 0,
  B11: 1,
  B111: 0,
  B112: 0,
  B119: 0,
  B12: 1,
  B120: 0,
  C: 1,
  C13: 1,
  C131: 1,
  C132: 1,
  C133: 1,
  C134: 1,
  C135: 1,
  C136: 1,
  C137: 1,
  C139: 1,
  C14: 1,
  C141: 1,
  C142: 1,
  C143: 1,
  C144: 1,
  C145: 1,
  C146: 1,
  C149: 1,
  C15: 1,
  C151: 1,
  C152: 1,
  C153: 1,
  C16: 1,
  C161: 1,
  C162: 1,
  C169: 1,
  C17: 1,
  C171: 0,
  C172: 0,
  C173: 0,
  C174: 0,
  C175: 0,
  C176: 1,
  C177: 1,
  C178: 1,
  C18: 1,
  C181: 1,
  C182: 1,
  C183: 1,
  C19: 1,
  C191: 0,
  C192: 0,
  C193: 0,
  C194: 1,
  C195: 0,
  C20: 1,
  C201: 1,
  C202: 0,
  C203: 0,
  C204: 1,
  C21: 1,
  C211: 0,
  C212: 1,
  C213: 0,
  C214: 1,
  C219: 1,
  C22: 1,
  C221: 0,
  C222: 0,
  C223: 1,
  C23: 1,
  C231: 0,
  C232: 1,
  C24: 1,
  C241: 1,
  C242: 1,
  C243: 1,
  C244: 1,
  C245: 1,
  C246: 1,
  C25: 1,
  C251: 0,
  C252: 0,
  C253: 0,
  C254: 0,
  C26: 1,
  C261: 0,
  C262: 0,
  C263: 0,
  C264: 0,
  C265: 0,
  C266: 0,
  C267: 0,
  C268: 1,
  C27: 1,
  C271: 0,
  C272: 1,
  C273: 1,
  C274: 1,
  C275: 1,
  C276: 1,
  C277: 1,
  C278: 1,
  C28: 1,
  C281: 0,
  C282: 0,
  C283: 1,
  C29: 1,
  C291: 0,
  C292: 0,
  C30: 1,
  C301: 0,
  C302: 0,
  C303: 0,
  C304: 0,
  C305: 0,
  C306: 0,
  C307: 0,
  C308: 0,
  C309: 0,
  C31: 1,
  C311: 0,
  C312: 0,
  C313: 0,
  C314: 0,
  C32: 1,
  C321: 0,
  C322: 0,
  C323: 0,
  C324: 0,
  C325: 0,
  C33: 1,
  C331: 0,
  C332: 0,
  C333: 0,
  C334: 0,
  C335: 0,
  C336: 0,
  C337: 0,
  C338: 0,
  C339: 0,
  C34: 1,
  C341: 0,
  C342: 0,
  C343: 0,
  C344: 0,
  C345: 0,
  C346: 0,
  C347: 0,
  C348: 0,
  C349: 0,
  C35: 1,
  C351: 0,
  C352: 0,
  C353: 0,
  C354: 0,
  C355: 0,
  C356: 0,
  C357: 0,
  C358: 0,
  C359: 0,
  C36: 1,
  C361: 0,
  C362: 0,
  C363: 0,
  C364: 0,
  C365: 0,
  C366: 0,
  C367: 0,
  C37: 1,
  C371: 0,
  C372: 0,
  C373: 0,
  C374: 0,
  C375: 0,
  C376: 0,
  C377: 0,
  C378: 0,
  C379: 0,
  C38: 1,
  C381: 0,
  C382: 0,
  C383: 0,
  C384: 0,
  C385: 0,
  C386: 1,
  C387: 1,
  C389: 1,
  C39: 1,
  C391: 1,
  C392: 1,
  C393: 1,
  C394: 1,
  C395: 1,
  C396: 1,
  C397: 0,
  C398: 0,
  C399: 1,
  C40: 1,
  C401: 1,
  C402: 1,
  C403: 1,
  C404: 1,
  C405: 1,
  C409: 1,
  C41: 1,
  C411: 1,
  C412: 0,
  C419: 1,
  C42: 1,
  C421: 0,
  C422: 0,
  C43: 1,
  C431: 1,
  C432: 1,
  C433: 1,
  C434: 0,
  C435: 1,
  C436: 1,
  C439: 1,
  D: 1,
  D44: 1,
  D441: 1,
  D442: 1,
  D443: 1,
  D45: 1,
  D451: 1,
  D452: 1,
  D46: 1,
  D461: 1,
  D462: 1,
  D463: 1,
  D469: 1,
  E: 1,
  E47: 1,
  E471: 0,
  E472: 0,
  E479: 0,
  E48: 1,
  E481: 0,
  E482: 0,
  E483: 0,
  E484: 0,
  E485: 0,
  E486: 0,
  E487: 0,
  E489: 0,
  E49: 1,
  E491: 1,
  E492: 1,
  E499: 1,
  E50: 1,
  E501: 0,
  E502: 0,
  E503: 0,
  E509: 0,
  F: 1,
  F51: 1,
  F516: 1,
  F52: 1,
  F526: 1,
  F5265: 1,
  F5266: 1,
  G: 1,
  G53: 1,
  G533: 1,
  G54: 1,
  G541: 1,
  G544: 1,
  G55: 1,
  G551: 1,
  G552: 1,
  G553: 1,
  G56: 1,
  G561: 1,
  G562: 1,
  G563: 1,
  G57: 1,
  G571: 1,
  G572: 1,
  G59: 1,
  G591: 1,
  G593: 1,
  G594: 1,
  G595: 1,
  G596: 1,
  G599: 1,
  H: 1,
  H62: 1,
  H621: 1,
  H622: 1,
  M: 1,
  M73: 1,
  M731: 1,
  M732: 1,
  M733: 1,
  M734: 1,
  M74: 1,
  M746: 1,
  N: 1,
  N77: 1,
  N772: 1,
  N78: 1,
  N782: 1,
  O: 1,
  O80: 1,
  O803: 1,
  O808: 1,
  O81: 1,
  O811: 0,
  O82: 1,
  O822: 1,
  Q: 1,
  Q84: 1,
  Q841: 1
}

exports.industryCategoryArr = industryCategoryArr
exports.industryCategoryObj = industryCategoryObj


// WEBPACK FOOTER //
// ./src/util/industryCategory.js